import { NgModule } from '@angular/core';

import { SharedModule } from 'projects/ProjetoBaseAngular/app/shared.module';
import { ReportModule } from '../../report/report.module';
import { RelRecebimentoConvenioComponent } from './rel-recebimento-convenio.component';

@NgModule({
  imports: [
    SharedModule,
    ReportModule
  ],
  declarations: [
    RelRecebimentoConvenioComponent,
  ]
})
export class RelRecebimentoConvenioModule { }
